import * as React from 'react';

// BEEM notification bell. Stroke-based; defaults to currentColor so it inherits the surrounding
// text color; pass `color` to tint it explicitly.
export default ({ color = 'currentColor' } = {}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.9995 3C15.3132 3 17.9995 5.68629 17.9995 9V12.1064C17.9995 13.6532 18.9121 15.055 20.3267 15.6807C21.0341 15.9935 20.8111 17.0498 20.0376 17.0498H4.01807C3.25093 17.0496 3.02286 16.0052 3.72021 15.6855C5.109 15.0493 5.99951 13.6623 5.99951 12.1348V9C5.99951 5.68641 8.68597 3.0002 11.9995 3Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);
